const toFiniteNumber = (value) => {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }

  if (typeof value === 'string') {
    const parsed = Number.parseFloat(value.replace(/,/g, '').trim());
    return Number.isFinite(parsed) ? parsed : null;
  }

  return null;
};

export const getChallengeTotalDistanceMeters = (route) => {
  const exactMeters = toFiniteNumber(route?.stats?.distanceMeters);
  if (exactMeters && exactMeters > 0) {
    return exactMeters;
  }

  const roundedKm = toFiniteNumber(route?.stats?.distance);
  if (roundedKm && roundedKm > 0) {
    return roundedKm * 1000;
  }

  return 0;
};

export const isChallengeParticipantComplete = (participant, progressMeters, route) => {
  if (participant?.completedAt) {
    return true;
  }

  const totalDistanceMeters = getChallengeTotalDistanceMeters(route);
  const progress = toFiniteNumber(
    progressMeters !== undefined ? progressMeters : participant?.currentDistanceMeters
  ) || 0;

  return totalDistanceMeters > 0 && progress >= totalDistanceMeters;
};

// A trophy is earned the first time a challenge is completed and persists
// across restarts. After restart, completedAt is cleared and the historical
// completion lives in completions[] — but the user still owns the trophy.
export const hasChallengeTrophy = (participant) => {
  if (!participant) return false;
  if (participant.completedAt) return true;
  return Array.isArray(participant.completions) && participant.completions.length > 0;
};

// Convert a Firestore Timestamp / Date / string to a JS Date, or null.
const toDate = (value) => {
  if (!value) return null;
  if (value instanceof Date) return value;
  if (typeof value?.toDate === 'function') return value.toDate();
  if (typeof value === 'number') return new Date(value);
  if (typeof value === 'string') {
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  return null;
};

// Latest completion date — current completedAt if set, else most recent entry
// in completions[]. Used by the trophy cabinet for "Completed <relative date>".
export const getLatestCompletionDate = (participant) => {
  if (!participant) return null;
  const direct = toDate(participant.completedAt);
  if (direct) return direct;
  if (Array.isArray(participant.completions) && participant.completions.length > 0) {
    const dates = participant.completions
      .map((c) => toDate(c?.completedAt))
      .filter(Boolean)
      .sort((a, b) => b.getTime() - a.getTime());
    return dates[0] || null;
  }
  return null;
};
